import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Monitor, Download, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AppDesktopPage() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    toast.info('Download avviato — il file pesa circa 107 MB, attendi qualche minuto');
    const a = document.createElement('a');
    a.href = `${API}/desktop-app/download`;
    a.download = 'CR-Impianti-Elettrici-Windows.zip';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => setDownloading(false), 5000);
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="app-desktop-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">App Desktop</h1>
        <p className="text-slate-500 mt-1">Il gestionale come programma per Windows, senza browser</p>
      </div>

      <Card className="border-slate-200">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-slate-900 rounded-xl">
              <Monitor className="h-8 w-8 text-white" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-slate-900">CR Impianti Elettrici — Windows</h2>
              <p className="text-sm text-slate-500 mt-1">
                Versione aggiornata che si collega a <span className="font-mono text-slate-700">gestionale.crimpiantielettrici.it</span>.
                Pacchetto .zip (~107 MB), nessuna installazione richiesta.
              </p>
              <Button onClick={handleDownload} disabled={downloading} className="mt-4 bg-slate-900 hover:bg-slate-800 text-white" data-testid="download-desktop-app-btn">
                <Download className="h-4 w-4 mr-2" />{downloading ? 'Download in corso...' : 'Scarica per Windows (.zip)'}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-slate-200">
        <CardContent className="p-6">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-4">Come si installa</h3>
          <ol className="space-y-3">
            {[
              'Scarica il file .zip con il pulsante qui sopra',
              'Elimina la vecchia cartella del programma (se presente)',
              'Estrai lo zip in una cartella a tua scelta (es. Documenti)',
              'Apri la cartella "win-unpacked" e avvia "CR Impianti Elettrici.exe"',
              'Facoltativo: tasto destro sull\'exe → "Invia a" → "Desktop (crea collegamento)"',
            ].map((step, i) => (
              <li key={step} className="flex items-start gap-3 text-sm text-slate-700">
                <span className="flex-shrink-0 flex items-center justify-center h-6 w-6 rounded-full bg-slate-100 text-slate-600 text-xs font-bold">{i + 1}</span>
                {step}
              </li>
            ))}
          </ol>
          <div className="flex items-center gap-2 mt-5 p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
            <CheckCircle2 className="h-4 w-4 text-emerald-600 flex-shrink-0" />
            <p className="text-xs text-emerald-700">Gli aggiornamenti del gestionale sono automatici: l'app mostra sempre la versione online più recente. Devi riscaricare l'app solo se cambia l'indirizzo del sito.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
